// extracted by mini-css-extract-plugin
export default {"author":"ArticlePdf_author__dr0JP","lead":"ArticlePdf_lead__+4zh4"};